export enum CreateEntityTypesEnum {
  AUTO = 'auto',
  MANUAL = 'manual',
}
